<template>
  <footer class="footer">
    <dl>
      <dt>友情链接</dt>
      <dd>
        <a href="https://www.hzeyun.com/">慧正资讯</a> ｜
        <a href="https://www.ibuychem.com/">买化塑</a> ｜
        <a href="https://gqi.org.cn/">广东产品质量监督检验研究院</a> ｜
        <a href="http://www.cee.cn/">北京市环科院</a> |
        <a href="http://www.buct.edu.cn/">北京化工大学</a> |
        <a href="https://www.ecust.edu.cn/">华东理工大学</a>
      </dd>
    </dl>
    <div class="footer-row">
      <a class="tel" href="tel:4009-300-360">
        <img src="../../assets/images/nicon-tel.png" alt="">
        4009-300-360
      </a>
      <!-- <p class="license">
        <a href="https://zzlz.gsxt.gov.cn/businessCheck/verifKey.do?showType=p&serial=91440104340187537G-SAIC_SHOW_10000091440104340187537G1627457784705&signData=MEQCINeNokFlOwhVyLP7R6FJKlJ8rAqn8H/y98/zP25GUWGQAiCrCC8Xm/Fsuvq7rtxJqdhAhAGC1tTSAAOR6e6c7pHZ8A==">
          <img src="https://style.ibuychem.com/static/ibuychem/ffb0d91db2f7d22d63d7ee66b8ab874.png" />
        </a>
      </p> -->
    </div>
    <p>COPYRIGHT©广州慧正云科技有限公司ylcool.com <br />粤ICP备18136962号-5</p>
  </footer>
</template>

<script>
  import config from '../../common/config';
  export default {
    data() {
      return {
        randomImageSpecial: null // 随机特版
      }
    },
    mounted() {
      // 显示随机特版
      this.randomImageSpecial = createRandomImageSpecial(config.ENV);
    },
    beforeDestroy() {
      this.randomImageSpecial && this.randomImageSpecial.remove();
    }
  }
</script>

<style lang="less" scoped="scoped">
  .footer {
    background-color: #0b1853;
    color: #a4afe2;
    padding: 2rem;

    dl {
      display: flex;
      line-height: 2rem;

      dt {
        width: 12rem;
      }

      dd {
        a {
          display: inline-block;
          color: #a4afe2;
          margin-bottom: 1rem;
        }
      }
    }

    .company-name {
      display: block;
      font-weight: 400;
      text-align: center;
      padding: 1rem 0;
    }

    .tel {
      background-color: #1c2d7b;
      display: flex;
      align-items: center;
      justify-content: center;
      font-weight: bold;
      color: #a4afe2;
      border-radius: 2rem;
      padding: .5rem 1rem;
      width: 16rem;
      margin: 1rem 2rem 1rem 0;
      font-size: 1.6rem;
      font-style: italic;

      img {
        margin-right: 1rem;
        width: 1.8rem;
      }
    }

    p {
      text-align: center;
      line-height: 2rem;
    }
  }

  .license {
    text-align: center;
    padding: .5rem 0 1rem;

    a {
      color: #a4afe2;
      display: block;
      margin: 0 auto;
      width: 5rem;
    }

    img {
      display: block;
      width: 100%;
    }
  }

  .footer-row {
    padding: 1rem 0;
    display: flex;
    align-items: center;
    justify-content: center;
  }
</style>



// WEBPACK FOOTER //
// src/components/common/footer.vue